module.exports = __webpack_public_path__ + "static/media/PortadaFinca.ee666cc5.png";